import React from 'react'

/**
 * テキストフィールドのカーソル位置に文字列を挿入する
 * @param inputRef - テキストフィールドのref
 * @param currentValue - 現在の値
 * @param setValue - 値を更新する関数
 * @param insertText - 挿入するテキスト
 */
export const insertAtCursor = (
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement>,
  currentValue: string,
  setValue: (value: string) => void,
  insertText: string
): void => {
  const input = inputRef.current
  if (!input) return

  const start = input.selectionStart || 0
  const end = input.selectionEnd || 0

  // カーソル位置にテキストを挿入
  const newValue =
    currentValue.slice(0, start) + insertText + currentValue.slice(end)

  setValue(newValue)

  // フォーカスを戻してカーソル位置を設定
  // setTimeoutを使用してReactの更新後に実行
  setTimeout(() => {
    input.focus()
    const newPosition = start + insertText.length
    // setSelectionRangeメソッドの存在確認
    if (
      'setSelectionRange' in input &&
      typeof input.setSelectionRange === 'function'
    ) {
      input.setSelectionRange(newPosition, newPosition)
    }
  }, 0)
}

/**
 * テキストフィールドの選択範囲を取得する
 */
export const getSelectionRange = (
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement>
): { start: number; end: number } | null => {
  const input = inputRef.current
  if (!input) return null

  return {
    start: input.selectionStart || 0,
    end: input.selectionEnd || 0,
  }
}

/**
 * テキストフィールドの選択範囲を設定する
 */
export const setSelectionRange = (
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement>,
  start: number,
  end: number
): void => {
  const input = inputRef.current
  if (!input) return

  input.focus()
  // setSelectionRangeメソッドの存在確認
  if (
    'setSelectionRange' in input &&
    typeof input.setSelectionRange === 'function'
  ) {
    input.setSelectionRange(start, end)
  }
}
